// removed by extract-text-webpack-plugin
module.exports = {"plainText":"src-styles----texts-module---plainText---3Kt2a","subTitle":"src-styles----texts-module---subTitle---1M1Mx","bold":"src-styles----texts-module---bold---cv7n2","blueText":"src-styles----texts-module---blueText---oOK7v","comparisonHeader":"src-styles----texts-module---comparisonHeader---2J4g-"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/texts.module.styl
// module id = 93
// module chunks = 69602565020374 255206796060672